import { AgentsSectionProps } from 'sly/agentsPage/components/AgentsSection/AgentsSection.types';

export default function AgentsSection({
  children,
  className,
}: AgentsSectionProps) {
  return (
    <section className={`my-16 mx-auto text-left ${className}`}>
      {children}
    </section>
  );
}
